import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { endImpersonation, isImpersonating, reloadAt, setImpersonationNotice } from '@/utils/auth'

import Can from '../Can'

// While impersonating, End impersonation replaces Logout: it is the only way out and always
// returns to the support user's own account.
const handleEndImpersonation = () => {
  endImpersonation()
  setImpersonationNotice('ended')
  reloadAt('/dashboard/user-panel/profile')
}

const UserMenuModal = ({ onLogout }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="navmgr-hover-menu-user">
      <div className="hover-menu-arrow" />
      <div className="navmgr-hover-menu-user__inner">
        <div className="navmgr-hover-menu-user__inner__top-menu-items">
          <div className="hover-menu-item">
            <Link className="hover-menu-item__link" to="/dashboard/user-panel/profile">
              <span>{t('navbar:userMenu.profile')}</span>
            </Link>
          </div>
          <Can on={'Navbar'} to={'notifications'}>
            <div className="hover-menu-item">
              <Link className="hover-menu-item__link" to="/dashboard/user-panel/notifications">
                <span>{t('navbar:userMenu.emailNotifications')}</span>
              </Link>
            </div>
          </Can>
          <div className="hover-menu-item">
            <Link className="hover-menu-item__link" to="/dashboard/user-panel/password">
              <span>{t('navbar:userMenu.changePassword')}</span>
            </Link>
          </div>
        </div>
        {isImpersonating() ? (
          <div className="hover-menu-small-item" onClick={handleEndImpersonation}>
            <span>{t('navbar:userMenu.endImpersonation')}</span>
          </div>
        ) : (
          <div className="hover-menu-small-item" onClick={onLogout}>
            <span>{t('navbar:userMenu.logout')}</span>
          </div>
        )}
        <div
          className="hover-menu-small-item"
          onClick={() => window.open('/resources/Privacy_Policy_2019.pdf', '_blank')}
        >
          <span>{t('navbar:userMenu.privacyPolicy')}</span>
        </div>
        <div
          className="hover-menu-small-item"
          onClick={() => window.open('/resources/Terms_of_Service_2019.pdf', '_blank')}
        >
          <span>{t('navbar:userMenu.termsOfService')}</span>
        </div>
      </div>
    </div>
  )
}

UserMenuModal.propTypes = {
  onLogout: PropTypes.func,
}
export default UserMenuModal
